import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/600.css';
import './styles/tokens.css';
import './styles/app.css';
import { App } from './App';

const root = document.getElementById('root');
if (!root) throw new Error('Element #root fehlt');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Offline-Fähigkeit (Postenkarte am Einsatzort) – nur im fertigen Build, nicht im Entwicklungsserver.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch(() => {
      /* ohne Service Worker läuft die App normal, nur nicht offline */
    });
  });
}
